// segment snippet prettified, modulified, and typescriptified, with some mods
/* eslint-disable no-console */
const CDN = 'https://analytics.labeling-data.net';

const analytics: any = [];

export default function analyticsLoader(opts: { writeKey: string; skipPageCall?: boolean }) {
  if (analytics.initialize) return;
  if (analytics.invoked) {
    if (window.console && console.error) {
      console.error('Segment snippet included twice.');
    }
    return;
  }
  analytics.invoked = true;
  analytics.methods = [
    'trackSubmit',
    'trackClick',
    'trackLink',
    'trackForm',
    'pageview',
    'identify',
    'reset',
    'group',
    'track',
    'ready',
    'alias',
    'debug',
    'page',
    'once',
    'off',
    'on',
    'addSourceMiddleware',
    'addIntegrationMiddleware',
    'setAnonymousId',
    'addDestinationMiddleware',
  ];
  analytics.factory = function (method: any) {
    return function () {
      // eslint-disable-next-line prefer-rest-params
      const args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      analytics.push(args);
      return analytics;
    };
  };
  for (const key of analytics.methods) {
    analytics[key] = analytics.factory(key);
  }
  analytics.load = function (key: string, e: any) {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = CDN + '/analytics.js/v1/' + key + '/analytics.min.js';
    const first = document.getElementsByTagName('script')[0];
    first.parentNode!.insertBefore(script, first);
    analytics._loadOptions = e;
  };
  analytics._writeKey = opts.writeKey;
  analytics._cdn = CDN;
  analytics.SNIPPET_VERSION = '4.15.3';

  analytics.load(opts.writeKey);
  if (!opts.skipPageCall) {
    analytics.page();
  }

  // see https://github.com/vvo/analytics.js-loader/blob/master/index.js#L91
  const initialAnalytics = analytics;
  const actualAnalytics: any = {};

  window.analytics = initialAnalytics;

  initialAnalytics.methods.forEach(function (method: any) {
    actualAnalytics[method] = function () {
      // eslint-disable-next-line prefer-rest-params,prefer-spread
      (window.analytics as any)[method].apply(window.analytics, arguments);
    };
  });

  return actualAnalytics;
}
